/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Support_RequiredInputs */

const en_common_support_required = /** @type {(inputs: Common_Support_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subject and description are required`)
};

const zh_common_support_required = /** @type {(inputs: Common_Support_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请填写标题和问题描述`)
};

/**
* | output |
* | --- |
* | "Subject and description are required" |
*
* @param {Common_Support_RequiredInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_support_required = /** @type {((inputs?: Common_Support_RequiredInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Support_RequiredInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_support_required(inputs)
	return zh_common_support_required(inputs)
});
export { common_support_required as "common.support.required" }